import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgException = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.5,
		fill: "#FFFAEB",
		stroke: "#C27D04"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 4.5L6 8H10L7 11.5",
		stroke: "#C27D04",
		strokeLinecap: "round"
	})]
});
export default SvgException;
